import React, { useState, useEffect } from 'react';
import TrainingHistoryService from './TrainingHistoryService';
import Alert from 'react-bootstrap/Alert';
import filterFieldsForList from '../../common/functions/filterFieldsForList';
import filterDataForList from '../../common/functions/filterDataForList';
import schema from './jsonSchema';
import AdvanceList from '../../common/AdvanceList';
import { useNavigate } from 'react-router-dom';
import useHeaderGenerator from '../../common/functions/useHeaderGenerator';
import DirectoryService from 'components/app/directory/DirectoryService';

const TrainingHistoryList = ({profile, showHeader = true}) => {
  const [data, setData] = useState();
  const [columns, setColumns] = useState([]);
  const [error, setError] = useState('');
  const [noDataToShow, setNoDataToShow] = useState(true);
  const navigate = useNavigate();
  const convertDate = (date) => {
    console.log(date);
    const year = date[0];
    const month = date[1] < 10 ? '0' + date[1] : date[1];
    const day = date[2] < 10 ? '0' + date[2] : date[2];
    console.log(year + '-' + month + '-' + day);
    return year + '-' + month + '-' + day;
  };
  useEffect(() => {
    const jsonSchema = schema;
    const fieldsForList = filterFieldsForList(jsonSchema);
    setColumns(fieldsForList);
    let identifier = profile?.identifier;
    console.log('Profile', profile);
    if(profile === undefined) {
      const loggedProfile = DirectoryService.retrieveLoggedProfile();
      identifier = loggedProfile.identifier; 
    }
    TrainingHistoryService.retrieveAllTrainingHistoryByProfile(identifier)
      .then(data => {
        const updatedData = data.map(n => ({
          ...n,
          class: n.name,
          status: 'Booked',
          date: convertDate(n.date)
        }));
        console.log('Retrieved TrainingHistory data:', updatedData);
        setData(filterDataForList(updatedData, columns.map(c => c.accessor)));
        setNoDataToShow(!data.length > 0);
      })
      .catch(error => setError({ error: error.message }));
  }, [noDataToShow]);
  const buttonsConf = [
    {
      name: 'Create a new TrainingHistory',
      type: 'submit',
      variant: 'info',
      onClick: () => {
      console.log('Create a new TrainingHistory');
      navigate('/app/annoucements/create-form');
      }
    },
    {
      name: 'Save Draft',
      type: 'submit',
      variant: 'success',
      onClick: () => {
        console.log('Save Draft');
      }
    }
  ];
  const headerGenerated = useHeaderGenerator(
 'Training History',
 ' ',
 [] 
);
  return (
    <>
    {showHeader && headerGenerated}

      {noDataToShow && (
        <Alert key="warning" variant="warning">
          There's not any Training History to show.
        </Alert>
      )}
      {data && !noDataToShow && (
        <AdvanceList columns={columns} data={data} />
      )}
    </>
  );
};

export default TrainingHistoryList;